export function obfuscateIban(iban: string) {
  const obfuscatedIban = iban.split('');

  for (let i = 2; i < obfuscatedIban.length - 4; i++) {
    obfuscatedIban[i] = '*';
  }

  return obfuscatedIban.join('');
}
